// extracted by mini-css-extract-plugin
export default {"cls1":"npiRfDYAKlB2v8JfkzfD","cls2":"ztPlMWlvhi5gyEwrfrpd npiRfDYAKlB2v8JfkzfD"};